import { BaseFetch } from "../main-model"
export default class ReportSchedulelModel extends BaseFetch {
    getReportSchedulelBy = (data) =>
    this.authFetch({
      url: "report-schedule/getReportSchedulelBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportSchedulelClassRoomBy = (data) =>
    this.authFetch({
      url: "report-schedule/getReportSchedulelClassRoomBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    
}
